export default __webpack_public_path__ + "static/media/bg_result_win_mobile.064b47af.png";